<form [formGroup]="validationForm" class="flex flex-col w-full gap-6" (ngSubmit)="onSubmit()">
  <h2 class="text-center text-2xl">Fix Transactions</h2>
  <p>You have {{outlyingTransactionsCount}} transactions that are outside of the date range.</p>
  <div class="radio-group flex flex-col gap-4 items-start">
    <label>
      <input type="radio" formControlName="approach" value="merge" class="me-1"> Set the dates outside of the cash flow range to the start/end date
    </label>
    <label>
      <input type="radio" formControlName="approach" value="delete" class="me-1"> Delete all transactions outside of the cash flow's date range
    </label>
  </div>
  <div class="flex flex-row w-full justify-center gap-6">
    <tandem-button theme="outline" [onClick]="onCancel.bind(this)">Cancel</tandem-button>
    <tandem-button type="submit" theme="solid" [onClick]="onSubmit.bind(this)" [disabled]="validationForm.invalid">Save</tandem-button>
  </div>
</form>
